import {
  SEU_SPLITTER_COMPONENT_TYPE,
  SeuComponent,
  SeuOperatingCondition,
} from '@seu-types';

export function hasSplitterWarning(
  component: SeuComponent,
  operatingConditions: SeuOperatingCondition[]
): boolean {
  if (component.componentType !== SEU_SPLITTER_COMPONENT_TYPE) {
    return false;
  }

  // check if there are values missing for an operating condition
  const everyOperatingConditionHasValues = operatingConditions.every(
    (condition) => {
      return component.outputHandles?.every((handle) =>
        handle.values.some((value) => {
          if (value.operatingConditionId === condition.id) {
            if (value.isRemainder || value.value) {
              return true;
            }
            return false;
          }
          return false;
        })
      );
    }
  );

  return !everyOperatingConditionHasValues;
}
